/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { TEXT_CONSTANTS } from '@support/shared/constants/device.constants';
import { AccordionTextTemplateData } from '@core/aem/components/accordion-text/accordion-text.interface';

@Component({
  selector: 'tmo-accordion-text',
  templateUrl: './accordion-text.component.html',
  styleUrls: ['../../../../../style-sheets/components/page-titles.component.scss'],
})
export class AccordionTextComponent
  extends AuthorableComponent<AccordionTextTemplateData>
  implements OnInit, OnDestroy
{
  /**
   * html content for accordion
   */
  public html: string;
  /**
   * accordion header content
   */
  public accordionTitle: string;
  /**
   * desktop Image Url
   */
  public desktopImageUrl: string;
  /**
   * desktop LinkUrl
   */
  public desktopLinkUrl: string;
  /**
   * desktop Alt Text
   */
  public desktopAltText: string;
  /**
   * tablet Imag eUrl
   */
  public tabletImageUrl: string;
  /**
   * tablet Link Url
   */
  public tabletLinkUrl: string;
  /**
   * tablet Alt Text
   */
  public tabletAltText: string;
  /**
   * mobile Image Url
   */
  public mobileImageUrl: string;
  /**
   * mobile Link Url
   */
  public mobileLinkUrl: string;
  /**
   * mobile Text
   */
  public mobileAltText: string;
  /**
   * variable for device Type check
   */
  public deviceType: string;
  /**
   * DEVICE_DESKTOP
   */
  public DEVICE_DESKTOP: string;
  /**
   * DEVICE_TABLET
   */
  public DEVICE_TABLET: string;
  /**
   * DEVICE_MOBILE
   */
  public DEVICE_MOBILE: string;

  constructor(private commonUtilService: CommonUtilService) {
    super();
    this.DEVICE_DESKTOP = TEXT_CONSTANTS.DEVICE_DESKTOP;
    this.DEVICE_TABLET = TEXT_CONSTANTS.DEVICE_TABLET;
    this.DEVICE_MOBILE = TEXT_CONSTANTS.DEVICE_MOBILE;
  }

  public ngOnInit(): void {}

  /**
   * Sets the data for the specified component. This is required as the AEM module will use this method to populate
   * component data
   * @param data Input data for AEM component
   */
  public setData(data: AccordionTextTemplateData): void {
    if (this.validate(data)) {
      this.html = data.html;
      this.accordionTitle = data['accordion-header'];
      // If value does not come from AEM, we consider it as true and will display it.
      this.desktopImageUrl = data.desktopImageUrl ? data.desktopImageUrl : '';
      this.desktopAltText = data.desktopAltText ? data.desktopAltText : '';
      this.tabletImageUrl = data.tabletImageUrl ? data.tabletImageUrl : '';
      this.tabletAltText = data.tabletAltText ? data.tabletAltText : '';
      this.mobileImageUrl = data.mobileImageUrl ? data.mobileImageUrl : '';
      this.mobileAltText = data.mobileAltText ? data.mobileAltText : '';
      this.deviceType = this.commonUtilService.checkDevice();
    }
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data
   */
  public validate(data: AccordionTextTemplateData): boolean {
    if (data) {
      return true;
    }
  }

  public ngOnDestroy(): void {}
}
